export const GOOGLE_ANALYTICS_EVENTS = Object.freeze({
  FORM_START: 'form_start',
  FORM_SUBMIT: 'form_submit',
  SOCIAL_PROFILE_CLICK: 'social_profile_click',
});

export const HUBSPOT = 'hubspot';
